import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {StoreSummary} from '../../../../classes/models/store/StoreSummary';
import {UserService} from '../../../../services/http/user/user.service';
import {UserDetails} from '../../../../classes/models/user/UserDetails';
import {DataService} from '../../../../services/store/data.service';
import {ActivatedRoute} from '@angular/router';
import {UserStoresModalComponent} from './user-stores-modal/user-stores-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Authority} from '../../../../classes/enums/Authority';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.less'],
  imports: [
    SHARED_IMPORTS
  ]
})
export class UserDetailsComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private userService = inject(UserService);
  private dataService = inject(DataService);
  private modalService = inject(NgbModal);
  private destroyRef = inject(DestroyRef);
  private destroy$ = new Subject<void>();

  constructor() {
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();
    });
  }


  /** Full information about the selected user. */
  userDetails: UserDetails;
  /** The selected store. */
  selectedStore: StoreSummary;
  /** A list of all stores. */
  allStores: StoreSummary[] = [];

  ngOnInit(): void {
    this.selectedStore = this.dataService.selectedStore;
    this.allStores = this.dataService.stores;

    this.route.params.pipe(takeUntil(this.destroy$)).subscribe({
      next: () => {
        const userEmail = this.route.snapshot.paramMap.get('userEmail');
        this.getUserDetails(userEmail);
      }
    });
  }

  private getUserDetails(userEmail: string): void {
    this.userService.getUserDetails(userEmail)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
              next: userDetails => {
                this.userDetails = userDetails;
              }
            });
  }

  /**
   * Returns all store names, assigned to a user.
   */
  getUserStoresNames(): string {
    return this.allStores.filter(store => this.userDetails.stores.includes(store.slug)).map(store => store.name).join(', ');
  }

  /**
   * Checks if a current user has access to assign stores to users.
   */
  hasAccessToAssignStores(): boolean {
    return this.dataService.userHasAuthority(Authority.AUTH_MANAGE_USER_STORE_ACCESS);
  }

  /**
   * Opens a modal window to assign stores to a user.
   */
  assignStores(): void {
    const modalRef = UserStoresModalComponent.open(this.modalService, {
      user: this.userDetails,
      allStores: this.allStores
    });
    modalRef.result.then(() => {
      this.getUserDetails(this.userDetails.email);
    });
  }
}